(function () {
  'use strict';
  function init(root) {
    if (root.dataset.pfmReady === '1') return;
    var tabs = Array.from(root.querySelectorAll('[data-pfm-tab]'));
    var panes = Array.from(root.querySelectorAll('[data-pfm-pane]'));
    if (tabs.length < 2 || panes.length < 2) return;
    root.dataset.pfmReady = '1';
    function show(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panes.forEach(function (pane, i) { pane.hidden = i !== index; });
      if (focus) tabs[index].focus();
      window.dispatchEvent(new Event('resize'));
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        panes[index].animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
      }
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { show(index, false); });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); show(next, true); }
      });
    });
  }
  function scan(container) { container.querySelectorAll('[data-pfm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
